// src/pages/Contact.js 
import React from 'react'

const Contact = () => {
  return (
    <div className='content pageStyle'>
        <h1 className='pageTitle'>Contact Us</h1>
        <div className='divider'></div>
        <p className='pageContent'>Heave to capstan Plate Fleet aft fathom scallywag gibbet. To go on account boom topsail league brig bilge schooner.</p>
        <p className='pageContent'>Hang the jib maroon splice the main brace Plate Fleet provost sloop gibbet. Arr gibbet skysail dance the hempen jig Shiver me timbers strike colors cable. Jack Tar careen reef bilge rat run a shot across the bow gally ho.</p>
    </div>
  )
}

export default Contact 